<template>
  <div class="mt-3">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row class="mb-3">
      <b-col>
        <label>Contactos de preferencia</label>
      </b-col>
      <b-col class="text-right">
        <b-button
            v-if="!formularioAgregar && origen != 2"
            variant="outline-primary"
            size="sm"
            class="button-dentalia"
            @click="agregarContacto"
        >
          Agregar Contacto
        </b-button>
        <b-button
        v-if="!formularioAgregar && origen == 2"
        variant="outline-primary"
        size="sm"
        class="button-dentalia"
        @click="agregarContacto"
    >
      Agregar correo
    </b-button>
      </b-col>
    </b-row>

    <b-row v-if="formularioAgregar">
      <b-col>
        <b-form v-on:submit.prevent="guardarContacto" >
          <div>
            <label>Medio contacto: </label>
            <b-form-select
                v-model="contactoGuardar.idMedioContacto"
                :options="listaContacto"
                value-field="idMedioContacto"
                text-field="descripcion"
                :state="contactoGuardar.idMedioContacto != null"
            ></b-form-select>
            <b-form-invalid-feedback :state="contactoGuardar.idMedioContacto != null">
              Se debe seleccionar una opción
            </b-form-invalid-feedback>
          </div>
          <div>
            <div
                v-if="contactoGuardar.idMedioContacto === 1 || contactoGuardar.idMedioContacto === 2 || contactoGuardar.idMedioContacto === 4">
              <label>Número: *</label>
              <VuePhoneNumberInput
                  v-model="contactoGuardar.contacto"
                  maxlength="13"
                  default-country-code="MX"
                  :translations="traslationsTxt"
                  placeholder="Ingresa número a 10 dígitos: *"
                  :state="contactoGuardar.contacto != null"
              />
              <b-form-invalid-feedback :state="contactoGuardar.contacto != null">
                Debe ingresar un número
              </b-form-invalid-feedback>
            </div>
            <div v-if="contactoGuardar.idMedioContacto === 3">
              <label> Correo: *</label>
              <b-form-input
                  type="email"
                  v-model="contactoGuardar.contacto"
                  placeholder="Correo: "
                  max="5"
                  :state="contactoGuardar.contacto != null"
              ></b-form-input>
              <b-form-invalid-feedback :state="contactoGuardar.contacto != null">
                Debe ingresar un correo
              </b-form-invalid-feedback>
            </div>
          </div>

          <div style="display: flex; flex-direction: row; justify-content: center;">
            <div style="padding:1%">
              <b-button v-if="origen != 2" variant="outline-primary" class="mt-4" type="submit" size="sm">
                Guardar Contacto
              </b-button>
              <b-button v-else variant="outline-primary" class="mt-4" type="submit" size="sm">
                Guardar correo
              </b-button>
            </div>
            <div style="padding:1%">
              <b-button variant="outline-danger" class="mt-4" size="sm" @click="formularioAgregar=false"
              >Cancelar
              </b-button
              >
            </div>
          </div>
        </b-form>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <div style="justify-content: left; text-align: left">

          <div v-if="!formularioAgregar" >

            <b-table
                responsive
                style="text-align: center; margin-top: 2%; width: 100%"
                id="contactos"
                :items="contactoPaciente"
                :fields="encabezados"
                class="tabla-dentalia"
                :per-page="registrosPorPagina"
                :current-page="paginaActual"
            >
              <template v-slot:cell(seleccionar)="row">
                <b-form-radio
                    v-model="idMedioContactoPaciente"
                    name="some-radios"
                    :value="row.item.idMedioContactoPaciente"
                ></b-form-radio>
              </template>
            </b-table>
            <b-pagination
                v-if="contactoPaciente.length > 3"
                align="center"
                v-model="paginaActual"
                :total-rows="contactoPaciente.length"
                :per-page="registrosPorPagina"
            ></b-pagination>

          </div>

        </div>
      </b-col>
    </b-row>

  </div>
</template>

<script>
import {PacienteService} from "@/apiServices/paciente/PacienteService";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";

export default {
  name: "ContactoPaciente",
  components: {
    VuePhoneNumberInput,
  },
  props: {
    idPaciente: Number,
    origen: {
      type: Number, 
      // 1 viene de cualquier otro lado 
      // 2 viene de impresion pti
      default: 1 
    }
  },
  data: () => ({
    registrosPorPagina: 3,
    paginaActual: 1,
    pacienteService: new PacienteService(),
    listaContacto: [],
    contactoPaciente: [],
    contactoGuardar: {
      idMedioContacto: null,
      contacto: null,
    },
    encabezados: [
      {key: "medioContacto", label: "Medio"},
      {key: "contacto", label: "contacto"},
      {key: "seleccionar", label: "Seleccionar"},
    ],
    formularioAgregar: false,
    idMedioContactoPaciente: null,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.traerListaContacto();
    this.obtenerContactoPaciente();
  },
  watch: {
    idMedioContactoPaciente: function () {
      this.$emit("_setearValor", this.idMedioContactoPaciente);
      this.$forceUpdate();
    },
  },
  methods: {
    agregarContacto() {
      this.formularioAgregar = true;
    },
    traerListaContacto() {
      if(this.origen != 2){
      const urlContacto = this.$api + "catalogos/listaMediosContacto";
      this.$http
          .get(urlContacto)
          .then((response) => {
            if (response.data.data) {
              response.data.data.unshift({
                idMedioContacto: null,
                descripcion: "Medio contacto:",
              });
              this.listaContacto = response.data.data;
            }
          })
          .catch((err) => {
            this.showErroMsg(err);
          });
        }
        else{
          this.listaContacto = [{
            idMedioContacto: 3,
            descripcion: "CORREO"
          }];
          this.contactoGuardar = {
            idMedioContacto: 3,
            contacto: null,
          };
        }
    },
    obtenerContactoPaciente() {
      this.paginaActual = 1;
      const parametros = {idPaciente: this.idPaciente}
      this.pacienteService
          .obtenerMediosContactoPaciente(parametros)
          .then((r) => {
            this.contactoPaciente = this.origen == 2 ? r.filter(contacto => contacto.idMedioContacto === 3) : r;
          })
          .catch((err) => {
            console.error(err);
          });
    },
    guardarContacto() {
      if (this.contactoGuardar.idMedioContacto !== 3) {
        if (this.contactoGuardar.contacto.replace(/\s+/g, "").length !== 10) {
          this.$swal({
            icon: "warning",
            text: "Los números de teléfono deben ser de 10 dígitos",
            confirmButtonText: "OK",
            confirmButtonColor: "#0e6ba9",
          });
          return false;
        }
      }
      var datos = {
        idPaciente: this.idPaciente,
        idMedioContacto: this.contactoGuardar.idMedioContacto,
        contacto: this.contactoGuardar.contacto,
        idMedioContactoPaciente: null,
      };
      this.pacienteService.guardarMedioContacto(datos).then(() => {
        this.formularioAgregar = false;
        this.contactoGuardar = {
          idMedioContacto: null,
          contacto: null,
        };
        this.obtenerContactoPaciente();
      });
    },
  },
};
</script>

<style scoped>

</style>
